export function normalizeReportData(props) {
  return {
    context: {
      client: props.client?.name || '',
      dateFrom: props.dateFrom,
      dateTo: props.dateTo,
    },
    raw: {
      campaigns: props.campaigns || [],
      campaignInsights: props.campaignInsights || {},
      adsetRows: props.adsetRows || [],
      demographics: props.demographics || {},
    },
  };
}
